// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMamGroupMessage, MamSubAccount } from '@shared/utils/DirectMessages/DirectMamGroupMessage';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
export class MamGroupProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        var _a, _b, _c, _d;
        const factory = FieldsFactory;
        const message = new DirectMamGroupMessage();
        // User PIN
        message.mamGroupID = (_a = fieldSet.GetValue(factory.FIELD_ID)) === null || _a === void 0 ? void 0 : _a.toString();
        message.userID = (_b = fieldSet.GetValue(factory.FIELD_USER_ID)) === null || _b === void 0 ? void 0 : _b.toString();
        message.assetID = fieldSet.GetValue(factory.FIELD_ASSET_ID);
        message.counterAccountID = (_c = fieldSet.GetValue(factory.FIELD_COUNTER_ACCOUNT_ID)) === null || _c === void 0 ? void 0 : _c.toString();
        message.activeateMamFee = fieldSet.GetValue(factory.FIELD_ACTIVATE_MAM_FEE);
        const groups = fieldSet.GetGroups(FieldsFactory.MAM_SUBACCOUNT_GROUP);
        for (const group of groups) {
            const subA = new MamSubAccount();
            subA.accountNumb = (_d = group.GetValue(factory.FIELD_ACCOUNT_ID)) === null || _d === void 0 ? void 0 : _d.toString();
            subA.EMamManagementFeeType = group.GetValue(factory.FIELD_MAM_ACCOUNT_MANAGEMENT_FEE_TYPE);
            subA.managementFee = group.GetValue(factory.FIELD_MAM_ACCOUNT_MANAGEMENT_FEE);
            subA.performanceFee = group.GetValue(factory.FIELD_MAM_ACCOUNT_PERFORMANCE_FEE);
            subA.feeAssetID = message.assetID;
            message.subAccounts.push(subA);
        }
        return [message];
    }
}
